import React from 'react';
import { ShoppingCart, ArrowRight, Check, CreditCard } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const PlacingOrderPage = () => {
  const { login } = useAuth();

  const features = [
    'Pedidos pelo chat',
    'Catálogo integrado',
    'Pagamento inline',
    'Confirmação automática',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <ShoppingCart className="h-4 w-4" />
                Pedidos
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Receba <span className="text-green-500">pedidos</span> pelo chat
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Clientes podem fazer pedidos completos diretamente pelo WhatsApp ou Instagram.
              </p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                Começar gratuitamente
              </Button>
            </div>
            <div className="bg-green-50 rounded-3xl p-6">
              <div className="bg-white rounded-2xl shadow-sm p-4 mb-4">
                <p className="text-sm font-medium mb-2">🛒 Seu pedido:</p>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span>2x Pizza Grande</span>
                    <span>R$80,00</span>
                  </div>
                  <div className="flex justify-between">
                    <span>1x Refrigerante 2L</span>
                    <span>R$12,00</span>
                  </div>
                  <div className="border-t pt-2 flex justify-between font-bold">
                    <span>Total</span>
                    <span>R$92,00</span>
                  </div>
                </div>
              </div>
              <Button className="w-full bg-green-500 hover:bg-green-600">
                <CreditCard className="h-4 w-4 mr-2" /> Pagar agora
              </Button>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Comece a vender pelo chat</h2>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PlacingOrderPage;
